import M_TOOLKIT from '../../../../main/components/toolkit/index.js'
// 上报前验证
const verify = (instance, params) => {
    // 上报开关未开启，不进行上报
    if (!instance.reportSwitch) {
        return false
    }
    // 无痕埋点信息采集失败，不进行上报
    const data = params.content && params.content.data && params.content.data.record_list && params.content.data.record_list[0] || {}
    if (M_TOOLKIT.isObject(data.dom_params) && M_TOOLKIT.isEmptyValueObject(data.dom_params)) {
        return false
    }

    return true
}

export default verify